<template lang="pug">
ProtexWrapper(v-if='inExperiment' :product-line-data='data' endpoint='are')
  div(class='text-black font-bold') Design your cap in 3D and get a quote
  UniversalLink(
    link='PROTEX_ARE'
    :open-new-window='true'
    class='block text-center bg-primary text-black w-full mt-2 mb-4 px-8 py-3 uppercase text-xl font-bold'
    @click='$uiEvents.$emit("CapBuilderPDPClick", data)'
  ) Build Your Cap
</template>

<script setup lang="ts">
const { $uiEvents } = useNuxtApp()
const amplitude = useAmplitude()
const fitmentStore = useFitmentStore()

const { data } = defineProps<{
  data: ProductLine
}>()

const inExperiment = ref(false)

// A/B test for A.R.E. Builder UWP-13957
amplitude.onReady({
  experimentId: 'cap-builder',
  callback: (variant) => {
    if (variant.value !== 'treatment') return
    inExperiment.value = true
    emitBuilderButtonViewed()
  },
})

watch(fitmentStore.$state, async () => {
  emitBuilderButtonViewed()
})

function emitBuilderButtonViewed() {
  if (!inExperiment.value) return
  $uiEvents.$emit('CapBuilderPDPViewed', data)
}
</script>
